<template>
 <div style="text-align:center;"
  :style="{ background: `url(${require('@image/productSystemMobile_bg.png')})`, 'background-size': 'cover' }"
  class="scene-pc">
  <div class="home-scene-title">产品体系</div>
  <div class="horizontal-container">
   <div class="scroll-wrapper" ref="scrollRef">
    <div class="scroll-content">
     <div class="scroll-item" v-for="(item, index) in dataList" :key="index">
      <div class="scroll-item-item">
       <img style="display: inline-block;" class="card-img" alt="example" :src="getImgUrl(item)" />
       <div class="scroll-item-item-text">
        <span class="card-title">{{ item.input988275a1 }}</span>
        <div class="card-text card-text-mobile">{{ item.inputde060c84 }}</div>
       </div>

      </div>
     </div>
    </div>
   </div>
  </div>
  <learnmore path="/product"></learnmore>
 </div>
</template>

<script setup>
import { computed, nextTick, onMounted, onUnmounted, ref } from 'vue'
import learnmore from "@/components/learnmore.vue"
import BScroll from '@better-scroll/core'
import ScrollBar from '@better-scroll/scroll-bar'
import MouseWheel from '@better-scroll/mouse-wheel'
import Slide from '@better-scroll/slide'

const props = defineProps({
 dataList: {
  type: Array,
  default: () => []
 }
})
const getImgUrl = (item) => {
 if (item['picture-uploadc8da899c'] && item['picture-uploadc8da899c'].length > 0) {
  return item['picture-uploadc8da899c'][0].url
 } else {
  return ""

 }
}
const dataList = computed(() => props.dataList)


const bsInstance = ref(null)
const scrollRef = ref(null)
const initScroll = async () => {
 await nextTick()
 BScroll.use(Slide)
 BScroll.use(ScrollBar)
 BScroll.use(MouseWheel)

 bsInstance.value = new BScroll(scrollRef.value, {
  scrollX: true,
  scrollY: false,
  probeType: 3,
  slide: {
   loop: true,
   autoplay: {
    interval: 2000, // 3秒切换一次
    pauseOnHover: true // 鼠标悬停暂停
   }
  },
  scrollbar: {
   fade: true,
   interactive: true
  },
  mouseWheel: {
   speed: 20,
   invert: false,
   easeTime: 300
  },
  momentum: {
   threshold: 1,
   speed: 800,
   easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)'
  },
  bounce: {
   left: true,
   right: true
  },
  useTransition: true,
  HWCompositing: true
 })
}
onMounted(() => {
 initScroll()
})
onUnmounted(() => {
 bsInstance.value.destroy()
})


</script>

<style lang="less" scoped>
.scene-pc {
 font-family: 'PuHuiTi';
}

.home-scene-title {
 padding-top: 20px;
 font-size: 36px;
 font-weight: 500;
 letter-spacing: 1px;
 color: #333333;
}



.home-scene-cards {
 margin-top: 8rem;
 display: flex;
 overflow-x: auto;

}


.horizontal-container {
 width: 100%;
 overflow: hidden;
 padding: 0 10px;

 margin-top: 8rem;
}

.scroll-wrapper {
 width: 100%;
 overflow: hidden;
}

.scroll-content {
 display: inline-flex;
 will-change: transform;
}

.scroll-item {
 width: 260px;
 height: 350px;
 margin-right: 20px;
 margin-left: 30px;
 border-radius: 5px;
 overflow: hidden;
}

.scroll-item-item {
 height: 100%;
 width: 100%;
 display: flex;
 flex-direction: column;
 overflow: hidden;
}

.card-img {
 width: 100%;
 height: 100%;
 object-fit: cover;
}

.item-text {
 margin-top: 8px;
 font-size: 14px;
 text-align: center;
}

.scroll-item-item-text {
 background: #fff;
 height: 100%;
 padding-top: 10px;
 font-size: 14px;
 text-align: center;
 padding-left: 10px;
 padding-right: 10px;
}

.card-title {
 font-family: "PuHuiTiRegular";
 font-size: 20px;
 font-weight: bold;

 color: #333333;
}

.card-text {
 font-family: "PuHuiTiRegular";
 font-size: 14px;
 font-weight: 350;
 color: #666666;
 height: 85px;
 overflow: hidden;
 text-overflow: ellipsis;
 display: -webkit-box;
 -webkit-line-clamp: 4;
 -webkit-box-orient: vertical
}
</style>

<style>
.home-scene-cards .ant-card-body {
 padding: 2.4rem;
}
</style>
